import { Middleware } from "../middleware"

export default {

    getSiemById(id) {
        return new Middleware()
            .method('GET')
            .append(`/odin/siem/${id}`)
            .build()
    },

    putSiemManagement(id, data) {
        return new Middleware()
            .method('PUT')
            .append(`/odin/siem/${id}`)
            .params(data)
            .build()

    },
    getSiemManagement(filter) {
        return new Middleware()
            .method('GET')
            .append(`/odin/siem`)
            .params({
                findBy: filter.search,
                page: filter.page,
                size: filter.size
            })
            .build()

    },


    saveSIEM(customer) {
        return new Middleware()
            .method('POST')
            .append(`/odin/siem/`)
            .setData(customer)
            .build()
    },

    updateSIEM(customer, id) {
        return new Middleware()
            .method('PUT')
            .append(`/odin/siem/${id}`)
            .setData(customer)
            .build()

    },
    deleteSIEM(id) {
        return new Middleware()
            .method('DELETE')
            .append(`/odin/siem/${id}`)
            .build()
    },

}